import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import WalletShopProducts from './pages/WalletShopProducts';
import CreateWalletShopProduct from './pages/CreateWalletShopProduct';
import UpdateWalletShopProduct from './pages/UpdateWalletShopProduct';
import PremiumBundleEditor from './pages/PremiumBundleEditor';
import StickerPackEditor from './pages/StickerPackEditor';
import CreateBanner from './pages/CreateBanner';
import Banners from './pages/Banners';
import BannerDetails from './pages/BannerDetails';
import SectionDetails from './pages/SectionDetails';
import LiveFilters from './pages/LiveFilters';
import CreateLiveFilter from './pages/CreateLiveFilter';
import LiveBackgrounds from './pages/LiveBackgrounds';
import CreateLiveBackground from './pages/CreateLiveBackground';
import GiftAnimations from './pages/GiftAnimations';
import CreateGiftAnimation from './pages/CreateGiftAnimation';
import BulkStickerUpload from './pages/BulkStickerUpload';
import BulkStickerThumbnailUpdate from './pages/BulkStickerThumbnailUpdate';
import CreateEventGift from './pages/CreateEventGift';
import AnnouncementList from './pages/AnnouncementList';
import ManageAnnouncementAssets from './pages/ManageAnnouncementAssets';
import LiveMilestoneBadges from './pages/LiveMilestoneBadges';
import LiveBadges from './pages/LiveBadges';
import LiveStickers from './pages/LiveStickers';
import CreateLiveSticker from './pages/CreateLiveSticker';
import EditLiveSticker from './pages/EditLiveSticker';
import LiveFrames from './pages/LiveFrames';
import CreateLiveFrame from './pages/CreateLiveFrame';
import EditLiveFrame from './pages/EditLiveFrame';
import AuthProvider from './components/AuthProvider';
import LiveQuestAssets from './pages/LiveQuestAssets';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ToastContainer position='top-center' autoClose={3000} />
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/products' element={<WalletShopProducts />} />
        <Route path='/products/new' element={<CreateWalletShopProduct />} />
        <Route path='/products/update' element={<UpdateWalletShopProduct />} />
        <Route path='/products/premium-bundles/new' element={<PremiumBundleEditor />} />
        <Route path='/products/premium-bundles/edit' element={<PremiumBundleEditor />} />
        <Route path='/products/sticker-packs/new' element={<StickerPackEditor />} />
        <Route path='/products/sticker-packs/edit' element={<StickerPackEditor />} />
        <Route path='/banners' element={<Banners />} />
        <Route path='/banners/new' element={<CreateBanner />} />
        <Route path='/banners/:screen/section/:sectionId/banner/:bannerId' element={<BannerDetails />} />
        <Route path='/banners/:screen/section/:sectionId' element={<SectionDetails />} />
        <Route path='/live-filters' element={<LiveFilters />} />
        <Route path='/live-filters/new' element={<CreateLiveFilter />} />
        <Route path='/live-backgrounds' element={<LiveBackgrounds />} />
        <Route path='/live-backgrounds/new' element={<CreateLiveBackground />} />
        <Route path='/live-stickers' element={<LiveStickers />} />
        <Route path='/live-stickers/new' element={<CreateLiveSticker />} />
        <Route path='/live-stickers/:stickerId/edit' element={<EditLiveSticker />} />
        <Route path='/live-frames' element={<LiveFrames />} />
        <Route path='/live-frames/new' element={<CreateLiveFrame />} />
        <Route path='/live-frames/:frameId/edit' element={<EditLiveFrame />} />
        <Route path='/gift-animations' element={<GiftAnimations />} />
        <Route path='/gift-animations/new' element={<CreateGiftAnimation />} />
        <Route path='/products/stickers/bulk' element={<BulkStickerUpload />} />
        <Route path='/products/stickers/bulk-update-thumbnails' element={<BulkStickerThumbnailUpdate />} />
        <Route path='/products/event-gifts/new' element={<CreateEventGift />} />
        <Route path='/announcements' element={<AnnouncementList />} />
        <Route path='/announcements/:id/assets' element={<ManageAnnouncementAssets />} />
        <Route path='/live-milestone-badges' element={<LiveMilestoneBadges />} />
        <Route path='/live-badges' element={<Navigate to='/live-badges/top-fan' replace />} />
        <Route path='/live-badges/top-fan' element={<LiveBadges key='top-fan' section='top-fan' />} />
        <Route path='/live-badges/daily-streak' element={<LiveBadges key='daily-streak' section='daily-streak' />} />
        <Route path='/live-badges/pingtop-level' element={<LiveBadges key='pingtop-level' section='pingtop-level' />} />
        <Route path='/live-quest-assets' element={<LiveQuestAssets />} />
        <Route path='/entry-animations' element={<Navigate to='/products?category=LIVE' replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
